export const aciGrade = {
    iconName: 'grade',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 32 32' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M18.052.72A2.589 2.589 0 0119.843 0h9.568A2.589 2.589 0 0132 2.589v8.745c0 .705-.288 1.38-.796 1.867L13.222 30.464c-1.041 1-2.7.955-3.685-.101L.697 20.89a2.589 2.589 0 01.1-3.636L18.053.72zm1.791 1.32a.549.549 0 00-.38.152L2.21 18.728a.55.55 0 00-.022.771l8.84 9.472a.55.55 0 00.783.022L29.79 11.73a.549.549 0 00.17-.396V2.589a.55.55 0 00-.55-.55h-9.568z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M23.92 5.93c0 .886.664 1.772 1.772 1.772 1.107 0 1.772-.665 1.772-1.772 0-1.108-.665-1.772-1.772-1.772-1.108 0-1.772.664-1.772 1.772z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
